export default __webpack_public_path__ + "static/media/leadership.b31a6ad5.png";